import { STATUS_LABEL, STATUS_TONE, resolveOrderStatus } from "@/lib/format";

/**
 * StatusBadge — accetta:
 *  - `status` (string): retro-compatibile con uso esistente
 *  - `order` (object) + `audience`: Phase 43.18d, calcola lo stato virtuale
 *    cancelled_refund_pending / cancelled_refunded / cancelled_refund_failed_*.
 */
export default function StatusBadge({ status, order, audience = "customer", className = "" }) {
  const resolved = order ? resolveOrderStatus(order, audience) : status;
  const tone = STATUS_TONE[resolved] || STATUS_TONE.pending;
  return (
    <span className={`pill whitespace-nowrap ${tone.bg} ${tone.fg} ${className}`} data-testid={`status-badge-${resolved}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
      {STATUS_LABEL[resolved] || resolved}
    </span>
  );
}
